import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { DateRangePicker } from 'react-dates';
import { connect } from 'react-redux';
import { doUpdateStipend } from '../../ducks/stipends.js';
import { Form, Header, Segment } from 'semantic-ui-react';
import 'react-dates/lib/css/_datepicker.css';
import 'semantic-ui-css/components/form.min.css';
import 'semantic-ui-css/components/header.min.css';
import 'semantic-ui-css/components/table.min.css';
import 'semantic-ui-css/components/segment.min.css';
import './edit-form.css';

const END_DATE_ID = 'stipendExpirationnDate';
const START_DATE_ID = 'stipendStartDate';

export class StipendEditForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      editedStipend: {
        ...props.stipend,
        created_at: undefined,
        updated_at: undefined,
      },
      startDate: moment(props.stipend.starts_at).zone('-06:00') || moment(),
      endDate:
        moment(props.stipend.expires_at).zone('-06:00') ||
        moment().endOf('month'),
      focusedDateInput: null,
    };
  }

  handleSubmit = () => {
    this.props.actions.doUpdateStipend(this.state.editedStipend);
  };

  handleFieldChange = (event) => {
    let stipend = {};

    if (event.target.name === 'amount') {
      stipend[event.target.name] = parseInt(event.target.value, 10) * 100;
    } else {
      stipend[event.target.name] = event.target.value;
    }

    this.setState((state) => {
      return {
        editedStipend: {
          ...state.editedStipend,
          ...stipend,
        },
      };
    });
  };

  onFocusChanged = (focusedDateInput) => {
    this.setState((prev) => {
      return {
        focusedDateInput,
        endDate: focusedDateInput
          ? prev.endDate
          : prev.endDate || moment().endOf('month'),
        startDate: focusedDateInput
          ? prev.startDate
          : prev.startDate || moment(),
      };
    });
  };

  onDatesChange = ({ startDate, endDate }) => {
    if (!startDate || !endDate) {
      return;
    }

    this.setState((state) => {
      return {
        startDate: startDate,
        endDate: endDate,
        editedStipend: {
          ...state.editedStipend,
          starts_at: startDate.startOf('day').format('YYYY-MM-DD HH:mm'),
          expires_at: endDate.endOf('day').format('YYYY-MM-DD HH:mm'),
        },
      };
    });
  };

  isOutsideRange = (d) => {
    if (this.state.focusedDateInput === END_DATE_ID) {
      return d < this.state.startDate;
    }

    return false;
  };

  _centAsDollar = (val = 0) => val / 100;

  render() {
    return (
      <div className="stipend-edit-form">
        <Header as="h2" attached="top">Edit Stipend</Header>
        <Segment attached="bottom" className="stipend-edit-container">
          <Form onSubmit={this.handleSubmit}>
            
            <div className="form-section">
              <h3>Stipend Information</h3>
              <div className="section-description">
                Update the stipend details
              </div>
              <Form.Group>
                <Form.Field width={8}>
                  <Form.Input
                    required
                    label="Stipend Name"
                    name="name"
                    placeholder="Enter stipend name"
                    value={this.state.editedStipend.name}
                    onChange={this.handleFieldChange}
                  />
                </Form.Field>
                <Form.Field width={8}>
                  <Form.Input
                    required
                    label="Amount"
                    type="number"
                    min={0}
                    icon="dollar"
                    iconPosition="left"
                    placeholder="0.00"
                    name="amount"
                    value={this._centAsDollar(this.state.editedStipend.amount)}
                    onChange={this.handleFieldChange}
                  />
                </Form.Field>
              </Form.Group>
            </div>

            <div className="form-section">
              <h3>Duration</h3>
              <div className="section-description">
                Update the start and end dates for this stipend
              </div>
              <Form.Field>
                <label>Date Range</label>
                <DateRangePicker
                  numberOfMonths={1}
                  startDateId={START_DATE_ID}
                  endDateId={END_DATE_ID}
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  onDatesChange={this.onDatesChange}
                  focusedInput={this.state.focusedDateInput}
                  isOutsideRange={this.isOutsideRange}
                  onFocusChange={this.onFocusChanged}
                />
              </Form.Field>
            </div>

            <div className="form-actions">
              <Form.Button type="submit" primary>
                Update Stipend
              </Form.Button>
            </div>
          </Form>
        </Segment>
      </div>
    );
  }
}

StipendEditForm.propTypes = {
  stipend: PropTypes.shape({
    id: PropTypes.number.isRequired,
    expires_at: PropTypes.string.isRequired,
    starts_at: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        doUpdateStipend,
      },
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(StipendEditForm);
